import React from 'react'
import {Form, Button, InputGroup, Col, Spinner} from 'react-bootstrap';
import {Link} from "react-router-dom";
import {Field, Formik} from "formik";
import {Input} from "../../../../ui/forms/formik";
import ErrorArea from "../../../../ui/forms/ErrorArea";
import {signInSchema} from "./SignInSchema";
import {userSignIn} from "../../../../../store/actions/AuthActions/SignInActions";
import {connect} from "react-redux";

const SignInForm = (props) => {
    const signInText = "Sign In";
    const {signIn, isSubmitting, errors} = props; // props.updateAction(data)

    const {USER_SIGN_IN_GENERAL_ERROR: generalError} = errors;

    const handleSubmit = (values, {setErrors}) => signIn({
        username: values.email,
        password: values.password,
    }).then(error => setErrors(error));

    return (
        <Formik
            initialValues={handleSubmit}
            validationSchema={signInSchema}
            onSubmit={handleSubmit}
            validateOnMount>
            {({
                  handleSubmit,
                  isValid,
                  dirty
              }) => (
                <Form className="formik submit-form-step" onSubmit={handleSubmit}>
                    <Form.Row className="form--row">
                        <Col xs={12} className="form--col email">
                            <Field
                                name="email"
                                type="email"
                                placeholder="Email"
                                component={SignInForm.Input}
                                className="input input-flat input-xl"
                            />
                        </Col>

                        <Col xs={12} className="form--col password">
                            <Field
                                name="password"
                                type="password"
                                placeholder="Password"
                                component={SignInForm.Input}
                                className="input input-flat input-xl"
                            />
                        </Col>
                    </Form.Row>

                    <Form.Group className="text-right">
                        <Link to="/forgot-password" className="forgot-pass">Forgot Password?</Link>
                    </Form.Group>

                    <Form.Row className="form--row">
                        <Col xs={12} className="form--col">
                            <Button className="submit" type="submit" variant="primary" size="xl" disabled={isSubmitting || !isValid} block>
                                <div className="d-flex justify-content-center align-content-center align-items-center">
                                    {isSubmitting && <Spinner className="spinner" animation="border" variant="primary"/>}
                                    <span className="mr-2"> {signInText} </span>
                                </div>
                            </Button>
                        </Col>
                    </Form.Row>

                    {
                        generalError &&
                        <Form.Row className="form--row mb-5 error-message">
                            <Col xs={12} className="form--col">
                                <ErrorArea message={generalError}/>
                            </Col>
                        </Form.Row>
                    }


                    <div className="sign-up-section mb-0 text-center">
                        <p>Dont have account on ScoutAfrique?</p>
                        <Link to="/signup">SignUp Now</Link>
                    </div>
                </Form>
            )}
        </Formik>
    );
};

SignInForm.Input = props => <Input errorMessagePosition="left-bottom" withoutMargin {...props}/>;

const mapStateToProps = state => {
    return {
        loggedIn: state.auth.signIn.success,
        isSubmitting: state.auth.signIn.loading,
        errors: state.auth.errors.signIn,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        signIn: (user) => dispatch(userSignIn(user)).then(() => window.location.href = '/dashboard'),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignInForm);
